import useLabels from "../../hooks/useLabels";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NotesModal from "./NotesModal";
import { useState } from "react";

import "./styles/index.scss";
import { CTA } from "../Generic";

const NotesButton = () => {
  const [getLabel] = useLabels();
  const [isNotesOpen, setIsNotesOpen] = useState(false);

  const openModal = () => setIsNotesOpen(true);
  const closeModal = () => setIsNotesOpen(false);

  return (
    <div className="notes_wrapper">
      <CTA
        onClick={openModal}
        customClassName="notes_button"
        title="Open Notes"
      >
        <FontAwesomeIcon icon={"fa-note-sticky"} size={"lg"} />
      </CTA>
      <NotesModal onClose={closeModal} isOpen={isNotesOpen} />
    </div>
  );
};

export default NotesButton;
